// @ts-nocheck
import React, { lazy } from 'react';
import { Dialog, DialogSuspense, FormattedMessage as T } from '@/components';

import withDialogRedux from '@/components/DialogReduxConnect';
import { compose } from '@/utils';

const ItemFormDialogContent = lazy(() =>
  import('./ItemFormDialogContent'),
);

// New item dialog for adding new item with variants, charges and decoration
function ItemDialog({
  dialogName,
  payload = { id: null, entryId: null },
  isOpen,
}) {
  return (
    <Dialog
      name={dialogName}
      className={'dialog--edit-item-form'}
      isOpen={isOpen}
      autoFocus={true}
      canEscapeKeyClose={true}
      style={{ width: '90vw', height: '90vh', maxWidth: 'none', maxHeight: '90vh', margin: 0, overflow: 'auto',paddingBottom: 0 }}
    >
      <DialogSuspense>
        <ItemFormDialogContent
          dialogName={dialogName}
          itemId={payload.id}
          entryId={payload.entryId}
        />
      </DialogSuspense>
    </Dialog>
  );
}

export default compose(withDialogRedux())(ItemDialog);
